import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { ListingCosts } from './types/Listing';

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingCosts>('GET', `/api/v2/listing/${listingId}/costs`);
